import React from 'react';
import { Section } from './Shared';
import { bonuses } from '../data/landing';
export const Bonuses = () => <Section className="max-w-5xl" data-id="element-16" data-mp="pk94aeupkr7z">
    <h2 className="text-[28px] md:text-5xl font-display font-bold leading-tight text-brand-purpleDark text-center" data-id="element-17" data-mp="pj6d05th4mrj">
      🎁 Tres bonus incluidos sin costo adicional
    </h2>

    <div className="mt-10 rounded-3xl bg-white/85 border border-brand-gold/40 grid md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-brand-gold/25" data-id="element-18" data-mp="fsv9gkdpcfl6">
      {bonuses.map(b => <div key={b.label} className="p-6 md:p-8 text-center md:text-left" data-id="element-19" data-mp="5w8mnq1tfegi">
          <div className="text-3xl" aria-hidden="true" data-id="element-20" data-mp="3o1v66hi83wq7">
            {b.emoji}
          </div>
          <p className="mt-3 text-xs font-bold tracking-[0.14em] text-brand-goldDark uppercase" data-id="element-21" data-mp="3t0g76j5aukfp">
            {b.label}
          </p>
          <h3 className="font-serif font-bold text-lg md:text-xl text-brand-purpleDark mt-1 leading-snug" data-id="element-22" data-mp="1mba0recz46pp">
            {b.title}
          </h3>
          <p className="text-base text-brand-text/85 mt-2 leading-relaxed" data-id="element-23" data-mp="1r6z1vm4n5vo4">
            {b.text}
          </p>
        </div>)}
    </div>

    <p className="mt-6 text-center font-medium text-brand-purple" data-id="element-24" data-mp="3dg4z8xjz44kq">
      Los tres incluidos con tu Megapack Saberes Ancestrales™.
    </p>
  </Section>;